var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMan = function SvgMan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 2.51a6.254 6.254 0 0 0-4.168 10.917 10 10 0 0 0-5.839 9.098v3.752c0 .69.56 1.25 1.25 1.25h2.65l1.114 8.913a1.25 1.25 0 0 0 1.24 1.095h7.506c.63 0 1.162-.47 1.24-1.095l1.115-8.913h2.649c.69 0 1.25-.56 1.25-1.25v-3.753a10.01 10.01 0 0 0-5.84-9.097A6.254 6.254 0 0 0 20 2.51m-.02 12.508h.041a7.506 7.506 0 0 1 7.486 7.506v2.503h-2.503c-.63 0-1.162.47-1.24 1.095l-1.114 8.913h-5.3l-1.114-8.913a1.25 1.25 0 0 0-1.24-1.095h-2.503v-2.503a7.507 7.507 0 0 1 7.487-7.506m.038-2.5a3.754 3.754 0 1 0-.036 0h.036",
    clipRule: "evenodd"
  })));
};
export default SvgMan;